class CollectionFilterCta extends HTMLElement {
  constructor() {
    super();
    this._toolbarPassed = false;
    this._contentEnding = false;
    this._toolbarObserver = null;
    this._endObserver = null;
    this._onToolbar = this._onToolbar.bind(this);
    this._onEnd = this._onEnd.bind(this);
  }

  connectedCallback() {
    const toolbar = document.querySelector(this.dataset.toolbarSelector);
    const endSentinel = document.querySelector(this.dataset.endSentinelSelector);

    if (toolbar) {
      this._toolbarObserver = new IntersectionObserver(this._onToolbar, { threshold: 0 });
      this._toolbarObserver.observe(toolbar);
    }

    if (endSentinel) {
      this._endObserver = new IntersectionObserver(this._onEnd, { rootMargin: '0px 0px 20% 0px', threshold: 0 });
      this._endObserver.observe(endSentinel);
    }
  }

  disconnectedCallback() {
    this._toolbarObserver?.disconnect();
    this._endObserver?.disconnect();
  }

  _onToolbar(entries) {
    for (const entry of entries) {
      this._toolbarPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
    }
    this._update();
  }

  _onEnd(entries) {
    for (const entry of entries) {
      // contentEnding = sentinel is in (or above) the trigger zone — i.e. user has reached / scrolled past the end of products
      this._contentEnding = entry.isIntersecting || entry.boundingClientRect.top <= 0;
    }
    this._update();
  }

  _update() {
    this.classList.toggle('is-visible', this._toolbarPassed && !this._contentEnding);
  }
}

if (!window.customElements.get('collection-filter-cta')) {
  window.customElements.define('collection-filter-cta', CollectionFilterCta);
}
